module.exports = __webpack_public_path__ + "components/flag/static/square/sy-fb0cd29388187cd11d96bb2610a8f0f3.svg";